export default __webpack_public_path__ + "static/media/shop4.39500298.png";